import { Stack, styled } from '@ethings/ui-toolkit';
import { Theme } from '@mui/material';
import { SxProps, unstable_styleFunctionSx as unstableStyleFunctionSx } from '@mui/system';
import { FC, ReactNode, type JSX } from 'react';

interface Props {
  children: ReactNode;
  spacing?: number;
  sx?: SxProps<Theme>;
}

const StyledStack = styled(Stack)<{ mergedSx?: SxProps<Theme> }>(({ mergedSx, theme }) => ({
  ...(unstableStyleFunctionSx({ sx: { padding: { xs: 1, sm: 2 }, ...mergedSx }, theme } as never) as Record<string, unknown>),
}));

export const InlineLayout: FC<Props> = ({ children, spacing = 2, sx }): JSX.Element => (
  <StyledStack
    spacing={spacing}
    height="fit-content" mergedSx={sx}
  >
    {children}
  </StyledStack>
);
